import { AnyAction } from 'redux';
import { App } from '@ps20-frontend/frontend-models';
import { GlobalActions, PreiseStreckeErmittelt } from '@ps20-frontend/shop-integration-redux';
import { PlzFaktoren } from '@ps20/bff-models';
import { VhvActions } from '../vhvActions';
import { IAppState } from '../appState';

export const plzFaktorenReducer = function (
  sectionState: PlzFaktoren = null,
  action: AnyAction,
  state: IAppState,
): PlzFaktoren {
  switch (action.type) {
    case VhvActions.PLZ_CHANGED:
    case VhvActions.ORT_CHANGED:
    case VhvActions.STRASSE_CHANGED:
    case VhvActions.HAUSNUMMER_CHANGED:
    case VhvActions.MAP_COORDINATES_VHV_CHANGED_EINGABE:
    case VhvActions.MAP_COORDINATES_VHV_CHANGED_ANGEBOT: {
      return null;
    }
    case GlobalActions.PREISE_STRECKE_ERMITTELT: {
      const actionPayload: PreiseStreckeErmittelt = action.payload;
      const taasResponsePayload = actionPayload.taasResponsePayload;
      if (
        actionPayload.appId === App.VHV_V2 &&
        state.angebotsId === actionPayload.angebotsId &&
        taasResponsePayload?.plzFaktoren
      ) {
        return { ...taasResponsePayload.plzFaktoren };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
